export class AigcServer {
  public static defaults = 'beta';
  public static envs = {
    development: 'https://aigc.beta.saybot.net',
    beta: 'https://aigc.beta.saybot.net',
    production: 'https://aigc-api.alo7.com',
  };

  public static get(inKey: string) {
    const envs = this.envs;
    return envs[inKey] || envs[this.defaults];
  }
}
